/* src/app/components/analytics/auto-redaction/auto-redaction/auto-redaction.component.scss */
table {
  width: 100%;
}
.left-column {
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  flex-grow: 1;
  max-width: 400px;
  margin-top: 20px;
  width: 100%;
}
.right-column {
  display: flex;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
.details-content {
  overflow: hidden;
  flex: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.card-container {
  justify-content: space-evenly;
  overflow: auto;
  width: 100%;
  margin-top: -40px;
}
.add-job-button {
  margin-bottom: 10px;
  margin-left: 45px;
  z-index: 10;
  margin-top: -10px;
}
.selected-item {
  background-color: #3f51b5;
  width: 6px;
  height: 100%;
  margin-top: 11px;
  margin-right: -21px;
  margin-left: 20px;
  border-radius: 5px 0px 0px 5px;
}
.filter-string {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}
/*# sourceMappingURL=auto-redaction.component.css.map */
